@let title = text();
@if (title && !question.source) {
  <div #label id="{{ question.id }}-label-content" [innerHTML]="title"></div>
}

<!-- Active charity groups -->
@for (group of activeGroups; track group.index) {
  @if (!$first) {
    <hr>
  }

  <div class="charity-gift-group" [class.deselected]="isDeselected(group)">
    <!-- Charity name heading with deselect toggle -->
    <div class="charity-gift-header">
      @if (question.source) {
        <h5 id="group-heading-{{ group.index }}" tabindex="-1"
            [class.upper-border]="$index !== 0">{{ group.name }}</h5>
      }
      @if (groupHasValidationError(group)) {
        <button class="btn btn-sm tertiary delete deselect-btn rounded-pill"
                type="button"
                [attr.aria-label]="'Remove ' + group.name"
                (click)="toggleGroup(group)">
                Remove
        </button>
      }
    </div>

    <!-- Group questions (excluding the shared question) -->
    @for (question of getDisplayQuestions(group); track question.id) {
      <div class="position-relative control"
           [class.has-validation-error]="questionHasValidationError(question.id!)">
        @if (group.locked) {
          <display-control
            [first]="$index === 0"
            [group]="group"
            [question]="question"
            [answer]="question.calculatedResponse!"></display-control>

        } @else {
          @if (question.type!.endsWith("TEXT")) {
            <text-control
              #questionControl
              [standalone]="false"
              [baseForm]="baseForm"
              [form]="this.form"
              [id]="question.id + '-wrapper'"
              [questionId]="question.id!"
              [groupIndex]="group.index"
              [question]="question"
              [editingResponse]="editingResponse"
              [onEnter]="onEnter"
              [hasValidationError]="questionHasValidationError(question.id!)"></text-control>

          } @else if (question.type === "CURRENCY") {
            <currency-control
              #questionControl
              [standalone]="false"
              [baseForm]="baseForm"
              [form]="this.form"
              [id]="question.id + '-wrapper'"
              [questionId]="question.id!"
              [groupIndex]="group.index"
              [question]="question"
              [editingResponse]="editingResponse"
              [onEnter]="onEnter"
              [hasValidationError]="questionHasValidationError(question.id!)"/>

          } @else if (question.type === "RADIO" || question.type === "CONFIRM_OPTION") {
            <radio-button-control
              #questionControl
              [standalone]="false"
              [baseForm]="baseForm"
              [form]="this.form"
              [id]="question.id + '-wrapper'"
              [questionId]="question.id!"
              [groupIndex]="group.index"
              [question]="question"
              [editingResponse]="editingResponse"
              [onEnter]="onEnter"
              [hasValidationError]="questionHasValidationError(question.id!)"/>

          } @else if (question.type === "CHECKBOX") {
            <checkbox-control
              #questionControl
              [standalone]="false"
              [baseForm]="baseForm"
              [form]="this.form"
              [id]="question.id + '-wrapper'"
              [questionId]="question.id!"
              [groupIndex]="group.index"
              [question]="question"
              [editingResponse]="editingResponse"
              [onEnter]="onEnter"
              [hasValidationError]="questionHasValidationError(question.id!)"/>

          } @else if (question.type === "DROPDOWN") {
            <dropdown-control
              #questionControl
              [standalone]="false"
              [baseForm]="baseForm"
              [form]="this.form"
              [id]="question.id + '-wrapper'"
              [questionId]="question.id!"
              [groupIndex]="group.index"
              [question]="question"
              [editingResponse]="editingResponse"
              [onEnter]="onEnter"
              [hasValidationError]="questionHasValidationError(question.id!)"/>

          } @else if (question.type === "NUMBER") {
            <number-control
              #questionControl
              [standalone]="false"
              [baseForm]="baseForm"
              [form]="this.form"
              [id]="question.id + '-wrapper'"
              [questionId]="question.id!"
              [groupIndex]="group.index"
              [question]="question"
              [editingResponse]="editingResponse"
              [onEnter]="onEnter"
              [hasValidationError]="questionHasValidationError(question.id!)"/>

          } @else if (question.type === "PERCENTAGE") {
            <percentage-control
              #questionControl
              [standalone]="false"
              [baseForm]="baseForm"
              [form]="this.form"
              [id]="question.id + '-wrapper'"
              [questionId]="question.id!"
              [groupIndex]="group.index"
              [question]="question"
              [editingResponse]="editingResponse"
              [onEnter]="onEnter"
              [hasValidationError]="questionHasValidationError(question.id!)"/>

          } @else if (question.type === "EMAIL") {
            <email-control
              #questionControl
              [standalone]="false"
              [baseForm]="baseForm"
              [form]="this.form"
              [id]="question.id + '-wrapper'"
              [questionId]="question.id!"
              [groupIndex]="group.index"
              [question]="question"
              [editingResponse]="editingResponse"
              [onEnter]="onEnter"
              [hasValidationError]="questionHasValidationError(question.id!)"/>

          } @else if (question.type === "POSTCODE") {
            <postcode-control
              #questionControl
              [standalone]="false"
              [baseForm]="baseForm"
              [form]="this.form"
              [id]="question.id + '-wrapper'"
              [questionId]="question.id!"
              [groupIndex]="group.index"
              [question]="question"
              [editingResponse]="editingResponse"
              [onEnter]="onEnter"
              [hasValidationError]="questionHasValidationError(question.id!)"/>

          } @else if (question.type === "DATE") {
            <date-control
              #questionControl
              [standalone]="false"
              [baseForm]="baseForm"
              [form]="this.form"
              [id]="question.id + '-wrapper'"
              [questionId]="question.id!"
              [question]="question"
              [groupIndex]="group.index"
              [editingResponse]="editingResponse"
              [onEnter]="onEnter"
              [hasValidationError]="questionHasValidationError(question.id!)"/>
          }
        }
      </div>
    }
  </div>
}

<!-- Deselected charities (shown as a dismissible list so user can re-select) -->
@if (deselectedGroups.length > 0) {
  <div class="deselected-charities mt-4">
    <p class="deselected-label">{{ messages.getText('label.removed-charities', 'Removed charities:') }}</p>
    @for (group of deselectedGroups; track group.index) {
      <div class="deselected-charity-item">
        <span class="charity-name">{{ group.name }}</span>
        <button class="btn btn-sm tertiary add reselect-btn rounded-pill"
                type="button"
                [attr.aria-label]="'Re-add ' + group.name"
                (click)="toggleGroup(group)">
          {{ messages.getText('btn.re-add-charity', 'Re-add') }}
        </button>
      </div>
    }
  </div>
}

<!-- Validation messages -->
@if (baseForm.interviewState()?.errors?.validations) {
  <div class="alert alert-warning warning pill form-warning-list row my-3" [attr.aria-live]="'assertive'">
    <i class="fa fa-exclamation-circle col-1 my-auto" aria-hidden="true"></i>
    <ul class="col-10 my-3 mx-3">
      @for (message of uniqueValidationMessages; track $index) {
        <li>{{ message }}</li>
      }
    </ul>
  </div>
}

<!-- Shared question (e.g. index-linked) — asked once, applied to all active groups -->
@if (sharedQuestion) {
  <div class="shared-question mt-6">
    <hr>
    @if (sharedQuestion.type === "RADIO" || sharedQuestion.type === "CONFIRM_OPTION") {
      <radio-button-control
        #questionControl
        [standalone]="false"
        [baseForm]="baseForm"
        [form]="this.form"
        [id]="sharedQuestion.id + '-wrapper'"
        [questionId]="sharedQuestion.id!"
        [question]="sharedQuestion"
        [editingResponse]="editingResponse"
        [onEnter]="onEnter"/>

    } @else if (sharedQuestion.type === "CHECKBOX") {
      <checkbox-control
        #questionControl
        [standalone]="false"
        [baseForm]="baseForm"
        [form]="this.form"
        [id]="sharedQuestion.id + '-wrapper'"
        [questionId]="sharedQuestion.id!"
        [question]="sharedQuestion"
        [editingResponse]="editingResponse"
        [onEnter]="onEnter"/>

    } @else if (sharedQuestion.type === "DROPDOWN") {
      <dropdown-control
        #questionControl
        [standalone]="false"
        [baseForm]="baseForm"
        [form]="this.form"
        [id]="sharedQuestion.id + '-wrapper'"
        [questionId]="sharedQuestion.id!"
        [question]="sharedQuestion"
        [editingResponse]="editingResponse"
        [onEnter]="onEnter"/>

    } @else {
      <text-control
        #questionControl
        [standalone]="false"
        [baseForm]="baseForm"
        [form]="this.form"
        [id]="sharedQuestion.id + '-wrapper'"
        [questionId]="sharedQuestion.id!"
        [question]="sharedQuestion"
        [editingResponse]="editingResponse"
        [onEnter]="onEnter"/>
    }
  </div>
}


<!-- Save and continue button -->
<div class="option-row row px-0 mt-8 mx-0">
  <div class="col px-0">
    <button class="btn primary rounded-pill confirm-button"
            [disabled]="baseForm.loading || baseForm.preventSave || activeGroups.length === 0"
            [attr.aria-label]="getLabel() + '.confirm_button'"
            (click)="saveAndContinue($event)"
            (keydown.enter)="saveAndContinue($event)">
      @if (baseForm.loading) {
        <span class="spinner-border spinner-border-sm mr-1"></span>
      }
      {{ messages.getText('WILL.button.save-and-continue') }}
    </button>
  </div>
</div>
